import React, { useRef, useEffect } from "react";

const DEBOUNCE_DELAY = 300;

const CustomNumberInput = ({ onChange, onBlur, ...rest }) => {
  const lastValueRef = useRef(null);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    const newValue = input.value;

    if (onChange) {
      onChange(e);
    }

    if (newValue !== lastValueRef.current) {
      clearTimeout(debounceTimeout.current!);

      // Salva tudo que você vai precisar ANTES do timeout
      const syntheticValue = newValue;

      debounceTimeout.current = setTimeout(() => {
        lastValueRef.current = syntheticValue;

        if (onBlur) {
          // Cria um evento "fake" com os dados necessários
          const fakeEvent = {
            target: { value: syntheticValue },
          };

          // Chama o onBlur com o valor correto
          onBlur(fakeEvent);
        }
      }, DEBOUNCE_DELAY);
    }
  };

  useEffect(() => {
    return () => {
      clearTimeout(debounceTimeout.current!);
    };
  }, []);

  return <input type="number" onInput={handleInput} onBlur={onBlur} {...rest} />;
};

export default CustomNumberInput;
